var $dad545c909cfec2d$exports = {};
const $dad545c909cfec2d$var$translateBtn = document.querySelector(".translate-button");
$dad545c909cfec2d$var$translateBtn.addEventListener("click", $dad545c909cfec2d$var$translateData);
const $dad545c909cfec2d$var$startOverBtn = document.querySelector(".start-over-button");
$dad545c909cfec2d$var$startOverBtn.addEventListener("click", $dad545c909cfec2d$var$addDisplayNone);
let $dad545c909cfec2d$var$text = "";
const $dad545c909cfec2d$var$languageInput = document.getElementsByName("language");
let $dad545c909cfec2d$var$selectedLanguage = "French";
function $dad545c909cfec2d$var$translateData() {
    try {
        const textInput = document.getElementById("textToTranslate");
        $dad545c909cfec2d$var$text = textInput.value;
        if ($dad545c909cfec2d$var$text.length > 0) {
            for(let i = 0; i < $dad545c909cfec2d$var$languageInput.length; i++)if ($dad545c909cfec2d$var$languageInput[i].checked) $dad545c909cfec2d$var$selectedLanguage = $dad545c909cfec2d$var$languageInput[i].value;
            $dad545c909cfec2d$var$callTranslateAPI();
        } else alert("enter text to translate");
    } catch (err) {
        console.error(err);
    }
}
async function $dad545c909cfec2d$var$callTranslateAPI() {
    try {
        const messages = [
            {
                role: "system",
                content: `you are a expert language translator. you translate given data into ${$dad545c909cfec2d$var$selectedLanguage} language`
            },
            {
                role: "user",
                content: $dad545c909cfec2d$var$text
            }
        ];
        const workerURL = "https://openai-api-worker.bhawnaislive.workers.dev/";
        const response = await fetch(workerURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(messages)
        });
        const data = await response.json();
        document.getElementById("inputScreen").classList.add("displayNone");
        document.getElementById("resultScreen").classList.remove("displayNone");
        document.getElementById("originalData").innerHTML = $dad545c909cfec2d$var$text;
        document.getElementById("translatedData").innerHTML = data.content;
    } catch (err) {
        console.error(err);
    }
}
function $dad545c909cfec2d$var$addDisplayNone() {
    document.getElementById("inputScreen").classList.remove("displayNone");
    document.getElementById("resultScreen").classList.add("displayNone");
    document.getElementById("textToTranslate").value = "";
    document.getElementById("originalData").innerHTML = "";
    document.getElementById("translatedData").innerHTML = "";
    $dad545c909cfec2d$var$languageInput[0].checked = true;
}


//# sourceMappingURL=index.a55b1d2d.js.map
